<div class="page-container">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="page-header">
    <h1 class="page-title">{{ 'pages.settings.title' | transloco }}</h1>
    <p class="page-description">{{ 'pages.settings.description' | transloco }}</p>
  </div>

  <!-- Mobile-only tab dropdown -->
  <div class="settings-tabs-mobile">
    <select
      class="settings-tabs-mobile__select"
      [ngModel]="selectedIndex"
      (ngModelChange)="onMobileSelectChange($event)"
      [attr.aria-label]="'pages.settings.title' | transloco">
      <option *ngFor="let slug of tabs; let i = index" [ngValue]="i">
        {{ ('pages.settings.tabs.' + slug) | transloco }}
      </option>
    </select>
    <i class="fas fa-chevron-down settings-tabs-mobile__chevron" aria-hidden="true"></i>
  </div>

  <mat-tab-group class="settings-tabs-desktop" mat-align-tabs="start" [(selectedIndex)]="selectedIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="{{ 'pages.settings.tabs.userAccount' | transloco }}">
      <div class="tab-content">
        <app-user-account></app-user-account>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'pages.settings.tabs.deletionRequests' | transloco }}">
      <div class="tab-content">
        <app-deletion-requests></app-deletion-requests>
      </div>
    </mat-tab>

  </mat-tab-group>

  <!-- Mobile content (driven by the dropdown above) -->
  <div class="settings-tabs-mobile-content">
    <div [ngSwitch]="selectedIndex">
      <app-user-account *ngSwitchCase="0"></app-user-account>
      <app-deletion-requests *ngSwitchCase="1"></app-deletion-requests>
    </div>
  </div>
</div>
